const ProfileScreen = () => {
  return <div>My profile</div>;
};

export default ProfileScreen;
